module.exports = __webpack_public_path__ + "img/brand-github.19c92265.svg";